import { FormRowActionMenuAction } from 'src/components/organisms/FormRowActionMenu';
import { FormStatusTab } from './types';

export type FormManagementActionMenuConfig = {
  hiddenActions: FormRowActionMenuAction[];
  disabledActions: FormRowActionMenuAction[];
};

export function getFormManagementActionMenuConfig(
  status: FormStatusTab,
): FormManagementActionMenuConfig {
  switch (status) {
    case FormStatusTab.ACTIVE:
      return {
        hiddenActions: ['edit', 'delete', 'archive'],
        disabledActions: [],
      };
    case FormStatusTab.DRAFTS:
      return {
        hiddenActions: ['edit', 'archive', 'unpublish'],
        disabledActions: [],
      };
    case FormStatusTab.UNPUBLISHED:
      return {
        hiddenActions: ['edit', 'delete', 'unpublish'],
        disabledActions: [],
      };
    case FormStatusTab.ARCHIVED:
      return {
        hiddenActions: ['edit', 'delete', 'archive', 'unpublish'],
        disabledActions: [],
      };
    default:
      return { hiddenActions: ['unpublish'], disabledActions: [] };
  }
}

export function getHiddenActionsForStatus(
  status: FormStatusTab,
): FormRowActionMenuAction[] {
  return getFormManagementActionMenuConfig(status).hiddenActions;
}

export function getDisabledActionsForStatus(
  status: FormStatusTab,
): FormRowActionMenuAction[] {
  return getFormManagementActionMenuConfig(status).disabledActions;
}
